function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * done
 */
import React from 'react';
import { useCssInJs, wrapReactionHook } from "../../hooks";
import { Suggest } from "../Suggest";
import { genUserPickerStyles } from "./styles";
import cx from 'classnames';
export var UserPicker = wrapReactionHook(function (props) {
  var prefix = 'form-user-picker';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genUserPickerStyles
    }),
    hashId = _useCssInJs.hashId,
    wrapSSR = _useCssInJs.wrapSSR;
  return wrapSSR( /*#__PURE__*/React.createElement(Suggest, _extends({
    url: "/ucenter/user/suggest",
    mapItem: {
      label: 'userName',
      value: 'userCode',
      description: 'pathName'
    },
    renderItem: function renderItem(item) {
      var data = item.data;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(hashId, prefix)
      }, /*#__PURE__*/React.createElement("div", {
        className: "label"
      }, data.label), /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, data.description));
    }
  }, props)));
});